// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uhA2W","content":"styles_content__3sLdZ"};